import { render, staticRenderFns } from "./Statement-notification-assignment-list.vue?vue&type=template&id=1c845968"
import script from "./Statement-notification-assignment-list.vue?vue&type=script&lang=js"
export * from "./Statement-notification-assignment-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports